export default {
    accept_document: "Принять",
    agreement_status_not_signed: "Не подписано",
    agreement_status_signed: "Подписано",
    all_other_countries: "Остальные страны",
    effective_at: "Дата начала действия",
    legal_agreement: "Соглашение",
    legal_document: "Юридический документ",
    legal_document_countries_note: "Если не выбрать ни одной страны, документ будет применяться ко всем странам, для которых нет отдельного документа этого типа.",
    legal_document_is_active_note: "Только одна версия документа этого типа и региона может быть активной. При активации этой версии предыдущая активная версия будет деактивирована автоматически.",
    legal_document_must_accept_note: "Для продолжения работы необходимо ознакомиться и принять документ.",
    legal_document_superadmin_authority_note: "Принимая документ, вы подтверждаете наличие полномочий действовать от имени организации.",
    legal_document_type: "Тип документа",
    legal_document_type_offer_contract: "Договор оферты",
    legal_document_type_integrations_agreement: "Соглашение на использование сторонних сервисов и интеграций",
    legal_document_type_usage_agreement: "Соглашение о пользовании программой",
    legal_document_usage_agreement_note: "Принимая документ, вы подтверждаете, что ознакомились с правилами использования программы и обязуетесь их соблюдать.",
    legal_documents: "Юридические документы",
    loading: "Загрузка",
    no_legal_documents_for_region: "Для вашего региона пока не опубликовано ни одного документа",
    open_document: "Открыть документ",
    requires_reacceptance: "Требуется повторное принятие",
    requires_reacceptance_note: "Если включено, пользователи, принявшие предыдущую версию, должны будут принять эту версию заново при следующем входе.",
    version: "Версия"
}
